import React, { useEffect, useState } from 'react';

import { ActivityIndicator } from 'antd-mobile';
import * as crypto from 'crypto-js';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import fangzhicuzhong from '../../static/images/fangzhicuzhong.png';
import tongyigongji from '../../static/images/tongyigongji.jpg';
import culixinsheng from '../../static/images/culixinsheng.jpg';
import utils from '../../utils/utils';
import {LOGIN_PAGE} from "../../config/config";
import styles from './activity.module.scss';

const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

function Activity(props: any) {
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //项目list
    const [projectList, setProjectList] = useState([]);


    useEffect(() => {
        //设置网页title
        document.title = '项目分类';

        //获取用户的项目列表
        api.getProject().then(res => {
            if (res.code == '0' && res.data.length > 0) {
                let filterArr: any = [];
                const _projectMap = {};
                for (let item of res.data) {
                    _projectMap[item.code] = item;
                    filterArr.push(
                        {
                            label: item.name,
                            value: item.code,
                            roleCode: item.roleCode
                        }
                    )
                }
                setProjectList(filterArr);
            }
        })
    }, [])

    function filterKeywords(projectKeyword: any){
        if(Array.isArray(projectKeyword)){
            const filteredList = projectList.filter((item: any) => !item.label.includes('同医共济') && !item.label.includes('防治卒中'));
            return filteredList.length > 0
        } else {
            return projectList.some((item: any) => item.label.includes(projectKeyword))
        }
        
    }

    const imgToLink = (item: any) => {
        sessionStorage.setItem("activityType", item.attrs);
        let toUrl = `/doctor/home?activity=${item.attrs}`
        props.history.push(toUrl)
    }

    return (
        <div className={LOGIN_PAGE === 'default' ? styles.login_content : styles['login_'+LOGIN_PAGE]}>
            <div className={styles.login_box}>
                { filterKeywords('防治卒中') &&
                    <img 
                    onClick={() => { imgToLink({attrs: 'FZCZ', type: 1}) }} 
                    src={fangzhicuzhong} 
                    style={{height:200, width:'100%', borderRadius: 8}} 
                    alt="防治卒中" /> 
                }           
                { filterKeywords('同医共济') &&
                    <img 
                        onClick={() => { imgToLink({attrs: 'TYGJ', type: 1}) }}
                        src={tongyigongji} 
                        style={{height:200, width:'100%', borderRadius: 8}} 
                        alt="同医共济" />
                }
                { filterKeywords(['防治卒中', '同医共济']) &&
                    <img 
                    onClick={() => { imgToLink({attrs: 'CLXS', type: 2}) }}
                    src={culixinsheng} 
                    style={{height:200, width:'100%', borderRadius: 8}} 
                    alt="卒力新生" />
                }
                
                
                
                {/* <div className={styles.header}>
                    <div className={styles.title_content}>
                        <div className={styles.title}>
                            科研数据小助手
                        </div>
                    </div>
                </div> */}
            </div>

            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
        </div>
    )
}

export default Activity;
